// Normalise a URL from YouTube / Vimeo / Loom / Wistia into an embeddable
// iframe URL. Returns null when the URL isn't recognised so callers can show
// a validation hint. Keeping this pure (no runtime deps) so both the builder
// and the public viewer stay thin.

const YT_RE = /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/i;
const VIMEO_RE = /vimeo\.com\/(?:video\/|channels\/[^/]+\/|groups\/[^/]+\/videos\/)?(\d{5,})/i;
const LOOM_RE = /loom\.com\/(?:share|embed)\/([A-Za-z0-9]{10,})/i;
const WISTIA_RE = /(?:wistia\.com\/medias\/|wistia\.net\/embed\/iframe\/)([A-Za-z0-9]{6,})/i;

export function parseVideoEmbed(url) {
  if (!url || typeof url !== "string") return null;
  const u = url.trim();
  if (!u) return null;

  let m = u.match(YT_RE);
  if (m) {
    return {
      provider: "youtube",
      id: m[1],
      embed: `https://www.youtube.com/embed/${m[1]}?rel=0`,
      thumbnail: `https://img.youtube.com/vi/${m[1]}/hqdefault.jpg`,
    };
  }
  m = u.match(VIMEO_RE);
  if (m) {
    return {
      provider: "vimeo",
      id: m[1],
      embed: `https://player.vimeo.com/video/${m[1]}`,
      thumbnail: null,
    };
  }
  m = u.match(LOOM_RE);
  if (m) {
    return {
      provider: "loom",
      id: m[1],
      embed: `https://www.loom.com/embed/${m[1]}`,
      thumbnail: null,
    };
  }
  m = u.match(WISTIA_RE);
  if (m) {
    return {
      provider: "wistia",
      id: m[1],
      embed: `https://fast.wistia.net/embed/iframe/${m[1]}`,
      thumbnail: null,
    };
  }
  return null;
}

export const VIDEO_BG_PALETTE = [
  "#5B4FE8", // Pragma purple
  "#0F172A", // Slate ink
  "#111827", // Charcoal
  "#1E3A8A", // Deep blue
  "#065F46", // Deep green
  "#9A3412", // Terracotta
  "#F8FAFC", // Mist (light)
  "#FFFFFF", // White
];

export function isLightColor(hex) {
  if (!hex) return false;
  const h = hex.replace("#", "");
  const full = h.length === 3 ? h.split("").map((c) => c + c).join("") : h;
  if (full.length !== 6) return false;
  const r = parseInt(full.slice(0, 2), 16);
  const g = parseInt(full.slice(2, 4), 16);
  const b = parseInt(full.slice(4, 6), 16);
  // Perceived luminance — anything above ~0.6 counts as "light" so we switch
  // text to a dark colour for readability.
  return (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255 > 0.6;
}
